import React, { useEffect, useState } from 'react';
import { Button } from '@lt/components';
import { scrollToFlights } from 'checkout/utils/globalUtils';
import { i18n } from '@lt/localization';

const baseCls = 'go-to-flights';

const GoToFlightButtonMobile = () => {
  const [areFlightsVisible, setAreFlightsVisible] = useState(false);
  const [isFooterVisible, setIsFooterVisible] = useState(false);

  useEffect(() => {
    /**
     * Нужно показывать кнопку, когда блок с перелетами скрыт,
     * а также на футере эта кнопка также не нужна
     */
    const handleIntersect: IntersectionObserverCallback = (entries) => {
      entries.forEach((entry) => {
        if (entry.target.className === 'checkout_page_new__main') {
          setAreFlightsVisible(entry.isIntersecting);
        }
        if (entry.target.tagName === 'FOOTER') {
          setIsFooterVisible(entry.isIntersecting);
        }
      });
    };

    const observer = new IntersectionObserver(handleIntersect);
    const routeContainer = document.querySelector('.checkout_page_new__main');
    const footer = document.getElementsByTagName('FOOTER')[0];

    if (routeContainer) {
      observer.observe(routeContainer);
    }

    if (footer) {
      observer.observe(footer);
    }

    return () => {
      if (routeContainer) {
        observer.unobserve(routeContainer);
      }
      if (footer) {
        observer.unobserve(footer);
      }
    };
  }, []);

  return (
    !isFooterVisible &&
    !areFlightsVisible && (
      <div className={`${baseCls}-fixed-container`}>
        <div className={`${baseCls}-container`}>
          <Button
            className={`${baseCls}-button`}
            primary
            onClick={scrollToFlights}
          >
            {i18n.t('checkout.packageInfo.flight.select')}
          </Button>
        </div>
      </div>
    )
  );
};

export default GoToFlightButtonMobile;
